export const STORAGE_TEST_EMAIL = 'iti.maintenance.testEmail';
export const STORAGE_REPLY_TO = 'iti.maintenance.replyTo';

export const VARIABLES = [
  { token: '{{client}}', label: 'Client' },
  { token: '{{site}}', label: 'Site' },
  { token: '{{url}}', label: 'URL' },
  { token: '{{sites}}', label: 'Sites' },
  { token: '{{urls}}', label: 'URLs' },
  { token: '{{serveur}}', label: 'Serveur' },
  { token: '{{date}}', label: 'Date' },
  { token: '{{heure_debut}}', label: 'Début' },
  { token: '{{heure_fin}}', label: 'Fin' },
];

export function readStored(key) {
  try {
    return window.localStorage.getItem(key) || '';
  } catch {
    return '';
  }
}

export function writeStored(key, value) {
  try {
    if (value) window.localStorage.setItem(key, value);
    else window.localStorage.removeItem(key);
  } catch {
    /* ignore quota / private mode */
  }
}

export function formatDateFr(isoDate) {
  if (!isoDate) return '';
  const [year, month, day] = isoDate.split('-');
  if (!year || !month || !day) return isoDate;
  return `${day}/${month}/${year}`;
}

export function siteEmail(site, overrides = {}) {
  return overrides[site.id] || site.email || '';
}

export function siteHasEmail(site, overrides = {}) {
  return Boolean(siteEmail(site, overrides));
}

export function groupRecipients(sites, groupByClient, overrides = {}) {
  if (!groupByClient) {
    return sites.map((site) => ({
      key: `s:${site.id}`,
      sites: [site],
      email: siteEmail(site, overrides),
      client: site.client_nom || '',
    }));
  }

  const buckets = new Map();
  sites.forEach((site) => {
    const key = site.client_id ? `c:${site.client_id}` : `s:${site.id}`;
    if (!buckets.has(key)) {
      buckets.set(key, {
        key,
        sites: [],
        email: '',
        client: site.client_nom || '',
      });
    }
    const group = buckets.get(key);
    group.sites.push(site);
    if (!group.email) group.email = siteEmail(site, overrides);
    if (!group.client && site.client_nom) group.client = site.client_nom;
  });

  return [...buckets.values()];
}

export function recipientStatusLabel(status) {
  if (status === 'sent') return 'envoyé';
  if (status === 'error') return 'erreur';
  return 'ignoré';
}
